import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)); }, []);

  return (
    <div data-testid="gallery-page" className="bg-ink text-white min-h-screen pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-mono text-xs uppercase tracking-[0.4em] text-adrenaline">From the Street</div>
        <h1 className="text-display text-6xl md:text-8xl uppercase leading-none mt-3">Builds & Stories</h1>
        <p className="text-zinc-400 mt-6 max-w-xl">Real builds from real owners. Tag <span className="text-white">@lonestarspeed</span> to be featured.</p>
        <div className="section-divider mt-12 mb-10" />
        <div className="grid grid-cols-2 md:grid-cols-3 gap-1">
          {items.map((g) => (
            <div key={g.id} className="relative aspect-square overflow-hidden bg-carbon hover-zoom group">
              <img src={g.image} alt={g.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="text-heading uppercase text-white">{g.title}</div>
                <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-300">{g.caption}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
